import templateUrl from './claim-types-select.component.html';
export const claimTypes = [
    { type: "apex:SuperUser", interfaceType: "checkbox" },
    { type: "apex:HubAtIcdCorporation", interfaceType: "corporationList" },
    { type: "apex:AuditorAtIcdCorporation", interfaceType: "corporationList" },
    { type: "apex:NationalConsultantAtIcdOffice", interfaceType: "officeList" },
    { type: "apex:RegionalConsultantAtIcdOffice", interfaceType: "officeList" },
    { type: "apex:PromotingOwnerAtIcdOffice", interfaceType: "officeList" },
    { type: "apex:OfficeRoleAtOffice", interfaceType: "" },
    { type: "apex:DivisionRoleAtDivision", interfaceType: "" },
    { type: "apex:OnRosterAtOffice", interfaceType: "officeList" },
    { type: "apex:RoleDelegator", interfaceType: "roleDelegator" },
    { type: "apex:TeamMember", interfaceType: "teamList" },
    { type: "apex:TeamLeader", interfaceType: "teamList" }
];

export const ClaimTypesSelectComponent = {
    templateUrl,
    bindings: {
        model: "=",
        change: "&onChange"
    },
    controllerAs: "vm",
    controller: class ClaimTypesSelectComponent {
        constructor() {
            'ngInject'
        }

        $onInit() {
            this.claimTypes = claimTypes;
        }

        onChange() {
            if (!this.model) {
                this.model = this.comboBox.value();
            }
            this.change();
        }
    }
}
